import {
  supabaseAuthenticatedApi,
  workspaceBackendUrl,
} from "../../../../components/SupabaseClient";

const submissionPathByIntent = {
  workspace: "/workspace/create",
  job: "/jobs/submit",
};

const getSubmissionPath = (intent) => {
  const path = submissionPathByIntent[intent];
  if (!path) throw new Error(`Unsupported experiment config intent: ${intent}`);
  return path;
};

export const validateExperimentConfigYaml = async (yamlText, intent) => {
  const response = await supabaseAuthenticatedApi.post(
    getSubmissionPath(intent),
    { yaml_text: yamlText, dry_run: true },
    workspaceBackendUrl,
    300000,
  );
  return response.json();
};

export const submitExperimentConfigYaml = async ({
  yamlText,
  intent,
  validationId,
}) => {
  const response = await supabaseAuthenticatedApi.post(
    getSubmissionPath(intent),
    {
      yaml_text: yamlText,
      dry_run: false,
      validation_id: validationId,
    },
    workspaceBackendUrl,
    300000,
  );
  return response?.json ? response.json() : null;
};

export const formatExperimentConfigValidationErrors = (validation) => {
  const errors = validation?.errors || [];
  if (errors.length) return errors;
  return "Config validation failed.";
};

export const formatExperimentSubmissionError = (error, fallback) => {
  if (error?.data?.valid === false) {
    return formatExperimentConfigValidationErrors(error.data);
  }
  return error?.message || fallback;
};
